import React from 'react'

import { Section6Data } from '../../constants'
import { section6HomeBg } from '../../assets/svg'
import { useStateContext } from '../../context/ContextProvider'
import {renderText} from "../hooks/TextVeiw"
const Section6Home = () => {
const {currentLang,currentMode} = useStateContext()
const isAr=currentLang==="ar"
    
  return (

    <section className='container'>
       <div className=" px-2  w-full h-[18rem] flex items-center justify-center  ">
       <div className=" Iconwrapper  flex-row">
          <ul className="flex items-center justify-center md:justify-start [&_li]:mx-4 [&_img]:max-w-none ">
            {Section6Data.icons.map((icon)=>
          (
<li key={icon.id}>
            <img src={currentMode === "Light" ? icon.icon : icon.darkIcon} className={`w-24 h-24 Iconitem Iconitem${icon.id}`} alt={icon.icon} />
        </li>
          )
          )}
          
          </ul>
          
          </div>
          </div>
   
  


    </section>
  )
}

export default Section6Home
